import { Space, Table } from "antd";
import { useTranslation } from "react-i18next";

import type { ColumnsType } from "antd/es/table";
import { IDoctor } from "@interfaces";
import { DeleteFilled, EditOutlined } from "@ant-design/icons";

import { memo } from "react";
import { SharedIconButton } from "@components";
const style = {
  background: "#00AA67",
  border: 0,
  borderRadius: "6px",
  height: "33px",
  width: "33px",
};
const deleteStyle = {
  background: "#EB5757",
};
interface IProps {
  data: IDoctor[];
  callbackEdit: (doctor: IDoctor) => void;
  callbackDelete: (doctor: IDoctor) => void;
}
export const DoctorTable = memo(({ data, callbackEdit, callbackDelete }: IProps) => {
  const { t } = useTranslation();

  const dataSource: IDoctor[] = data;

  const columns: ColumnsType<IDoctor> = [
    {
      title: t("page.no"),
      dataIndex: "key",
      key: "1",
      render: (item, record, index) => <>{index + 1}</>,
    },
    {
      title: t("page.provider_name"),
      dataIndex: "name",
      key: "2",
    },
    {
      title: t("page.samaId"),
      dataIndex: "samaId",
      key: "3",
    },
    {
      title: t("page.phoneNumber"),
      dataIndex: "phoneNumber",
      key: "4",
    },
    {
      title: t("page.actions"),
      key: "5",
      render: (_, record) => (
        <Space size="middle" key={record?._id}>
          <SharedIconButton
            onClick={() => callbackEdit(record)}
            style={style}
            icon={<EditOutlined />}
            size={"small"}
          />
          <SharedIconButton
            onClick={() => callbackDelete(record)}
            style={{ ...style, ...deleteStyle }}
            icon={<DeleteFilled />}
            size={"small"}
          />
        </Space>
      ),
    },
  ];

  return <Table dataSource={dataSource} rowKey={"samaId"} columns={columns} pagination={false} />;
});
